import { AsyncThunk } from '@reduxjs/toolkit';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/dist/mapBuilders';
import {
  DeleteRequest,
  PageState,
  allResourceNames,
  OkResponse,
} from 'store/types';
import omit from 'lodash-es/omit';
import { each } from 'lodash-es';

export default (
  builder: ActionReducerMapBuilder<PageState>,
  deleteRequest: AsyncThunk<
    OkResponse,
    DeleteRequest,
    {
      rejectValue: boolean;
    }
  >
) => {
  builder.addCase(deleteRequest.pending, (state) => {
    state.result = null;
  });
  builder.addCase(deleteRequest.fulfilled, (state, { meta }) => {
    each(allResourceNames, (name) => {
      let resource = state?.resources?.[name];

      if (resource) {
        resource.data = omit(resource.data, meta.arg._id);
      }
    });
  });
  builder.addCase(deleteRequest.rejected, (state) => {
    state.result = {
      type: 'error',
      message: 'Упс, кажется, что-то пошло не так',
    };
  });
};
